import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=bac4c138&scoped=true"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"
import style0 from "./sort.vue?vue&type=style&index=0&id=bac4c138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac4c138",
  null
  
)

export default component.exports